import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Switch } from '@material-ui/core';
import { hasDynamicSpaceoutAccess } from '../../../helpers/user';
import { useSwitchStyles } from '../../../hooks/useSwitchStyles';

export const DynamicSpaceoutSwitch = ({ selectedPricingGroup, isDynamicFxEvent, handleGroupAttrEdit }) => {
  const switchTheme = useSwitchStyles();

  const switchChecked = selectedPricingGroup?.dynamic_spaceout_enabled === true;

  const switchDisabled =
    selectedPricingGroup?.has_dynamic_spaceout === false && selectedPricingGroup?.dynamic_spaceout_enabled === false;

  if (!hasDynamicSpaceoutAccess() || !isDynamicFxEvent) {
    return null;
  }

  return (
    <Grid container direction="column" alignItems="center" spacing={0}>
      <Grid item>
        <Typography style={{ fontSize: '10px' }}>Dynamic</Typography>
      </Grid>
      <Grid item>
        <Switch
          checked={switchChecked}
          disabled={switchDisabled}
          color="primary"
          onChange={handleGroupAttrEdit('dynamic_spaceout_enabled', null)}
          classes={{
            root: switchTheme.root,
            switchBase: switchTheme.switchBase,
            thumb: switchTheme.thumb,
            track: switchTheme.track,
            checked: switchTheme.checked,
          }}
        />
      </Grid>
    </Grid>
  );
};

DynamicSpaceoutSwitch.propTypes = {
  selectedPricingGroup: PropTypes.shape({
    has_dynamic_spaceout: PropTypes.bool,
    dynamic_spaceout_enabled: PropTypes.bool,
  }),
  isDynamicFxEvent: PropTypes.bool.isRequired,
  handleGroupAttrEdit: PropTypes.func.isRequired,
};

DynamicSpaceoutSwitch.defaultProps = {
  selectedPricingGroup: null,
};

export default DynamicSpaceoutSwitch;
